// require("./lib/social");
// require("./lib/ads");
// var track = require("./lib/tracking");

require("component-responsive-frame/child");
require("angular");

var app = angular.module("power-rankings", []);

app.controller("rankingController", ["$scope", function($scope) {

  var weekly = {};
  window.rankings.forEach(function(row) {
    if (!weekly[row.week]) weekly[row.week] = [];
    weekly[row.week].push(row);
    row.logo = window.logos[row.team] ? window.logos[row.team].logo : "";
  });

  $scope.weeks = Object.keys(weekly).map(Number).sort((a, b) => a - b);

  var highest = $scope.weeks[$scope.weeks.length - 1];
  // Add previous result column
  for (var i = 2; i <= highest; i++) {
    var week = weekly[i];
    var last = weekly[i - 1];
    week.forEach(function(item) {
      var previous = last.filter(o => o.team == item.team).pop();
      if (previous) item.previous = previous.ranking;
    })
  }

  $scope.select = function(index) {
    $scope.selectedWeek = weekly[index];
    $scope.selected = index;
  };

  $scope.select(highest);

}]);

